// Shared category + status display helpers for Community Issues
export const CATEGORY_META = {
  water:        { icon: "🚰", label: "Water" },
  road:         { icon: "🛣️", label: "Road" },
  electricity:  { icon: "⚡", label: "Electricity" },
  street_light: { icon: "💡", label: "Street Light" },
  drainage:     { icon: "🚽", label: "Drainage" },
  garbage:      { icon: "🗑️", label: "Garbage / Cleanliness" },
  agriculture:  { icon: "🌾", label: "Agriculture / Irrigation" },
  transport:    { icon: "🚌", label: "Transport" },
  school:       { icon: "🏫", label: "School / Public Facility" },
  health:       { icon: "🏥", label: "Health Facility" },
  other:        { icon: "📍", label: "Other" },
};

export const STATUS_META = {
  reported:               { label: "Reported",                     color: "bg-amber-50 text-amber-800 border-amber-200",    dot: "bg-amber-500" },
  under_review:           { label: "Under Review",                 color: "bg-blue-50 text-blue-800 border-blue-200",       dot: "bg-blue-500" },
  awaiting_assignment:    { label: "Awaiting Assignment",          color: "bg-indigo-50 text-indigo-800 border-indigo-200", dot: "bg-indigo-500" },
  assigned:               { label: "Assigned",                     color: "bg-violet-50 text-violet-800 border-violet-200", dot: "bg-violet-500" },
  in_progress:            { label: "Action in Progress",           color: "bg-orange-50 text-orange-800 border-orange-200", dot: "bg-orange-500" },
  resolution_submitted:   { label: "Resolution Submitted",         color: "bg-sky-50 text-sky-800 border-sky-200",          dot: "bg-sky-500" },
  unable_to_resolve:      { label: "Unable to Resolve — Review",   color: "bg-rose-50 text-rose-800 border-rose-200",       dot: "bg-rose-500" },
  resolved:               { label: "Resolved",                     color: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  closed_not_resolved:    { label: "Closed — Not Resolved",        color: "bg-gray-100 text-gray-700 border-gray-300",      dot: "bg-gray-500" },
};

export const STATUS_ORDER = [
  "reported", "under_review", "awaiting_assignment", "assigned",
  "in_progress", "resolution_submitted", "resolved",
];

export const UNABLE_REASONS = [
  ["government_required", "Government department intervention required"],
  ["funding_unavailable", "Funding or budget unavailable"],
  ["higher_authority_approval", "Higher-authority approval required"],
  ["outside_my_authority", "Outside my authority"],
  ["legal_permission", "Legal permission required"],
  ["insufficient_resources", "Insufficient resources"],
  ["outside_my_area", "Outside my assigned area"],
  ["other", "Other"],
];
